<script lang="ts">
import type { NavContentTeaser, NavContentTeaserDocData } from '../../../../types/navContentTeaser';
import { computed, ref } from 'vue';

// TODO: NavContentTeaserDocData will be the default content-service response, clean up when on PROD
type Teaser = NavContentTeaser | NavContentTeaserDocData;

type Props = {
  teaser: Teaser;
};
</script>
<script setup lang="ts">
const props = defineProps<Props>();
const hasLoadError = ref<boolean>(false);

const isDocumentTeaser = (teaser: Teaser): teaser is NavContentTeaserDocData => {
  return 'document_data' in teaser;
};

const formattedTeaser = computed(() => {
  const teaser = isDocumentTeaser(props.teaser) ? props.teaser.document_data : props.teaser;
  const linkType =
    typeof teaser.pt_link_type === 'string'
      ? teaser.pt_link_type
      : teaser.pt_link_type?.identifier;

  return {
    title: teaser.pt_headline,
    subTitle: teaser.pt_copy,
    image:
      typeof teaser.pt_image_src === 'string'
        ? teaser.pt_image_src
        : teaser.pt_image_src?.resolutionsMetaData?.rs_w140_h116_image?.url,
    imageAlt: teaser.pt_image_alt,
    url:
      linkType === 'external'
      ? teaser.pt_link_url
      : teaser.pt_link_ref?.route,
    target: teaser.pt_link_target,
    linkType: teaser.pt_link_type,
  };
});

const loadError = () => {
  return (hasLoadError.value = true);
};
</script>

<template>
  <a
    :class="[
      $style.teaserLink,
      (!formattedTeaser.image || hasLoadError) && $style.navItemNoImage,
      formattedTeaser.linkType === 'external' && $style.externalLink,
    ]"
    :href="formattedTeaser.url"
    :target="formattedTeaser.target"
  >
    <div v-if="formattedTeaser.image && !hasLoadError" :class="$style.teaserImg">
      <img :alt="formattedTeaser.imageAlt" :onerror="loadError" :src="formattedTeaser?.image" />
    </div>
    <div :class="$style.teaserInfo">
      <span :class="$style.subTitle">{{ formattedTeaser.subTitle }}</span>
      <h3 :class="$style.title">{{ formattedTeaser.title }}</h3>
    </div>
  </a>
</template>
<style lang="scss" module src="../../MainNav.scss" />
